var exports = {
  "e4": "visualContainer__pMR50x",
  "dS": "clearOfClose__Cr-Sxz",
  "Cv": "visualImage__tJyP_v",
  "FK": "belowLarge__oEVemo",
  "nD": "mobileOnly__MNonMb",
  "Dw": "waveIn__8qfopV",
  "Yr": "wave-in__lQ2iiS",
  "ly": "slideIn__mm_rzV",
  "Uu": "slide-in__5l_JIj",
  "J0": "flipIn__MbNBj_",
  "sE": "flip-in__8hw43S",
  "qG": "fadeIn___ZyYJK",
  "dY": "fade-in__BfS4mv",
  "zm": "tabletOnly__iy8UX5",
  "DL": "largeUp__n1EozU",
  "WR": "desktopUp__mH526S",
};

module.exports = exports;
